import {z} from 'zod';
import {UserGroupItemType} from '../../constants';

export const UserGroupAutoListItemSchema = z.object({
	id: z.number().int().positive(),
	email: z.string().email(),
	name: z.string(),
	type: z.nativeEnum(UserGroupItemType),
});

export type IUserGroupAutoListItem = z.infer<
	typeof UserGroupAutoListItemSchema
>;
